import * as React from "react";
import { registerModalHost, type ModalOptions, type ModalButton } from "../services/modal";

interface ModalHostState {
  modal: ModalOptions | null;
}

/** Renders the active modal (one at a time). Mount once near the app root. */
export default class ModalHost extends React.Component<Record<string, never>, ModalHostState> {
  state: ModalHostState = { modal: null };
  private unregister?: () => void;

  componentDidMount(): void {
    this.unregister = registerModalHost((modal) => this.setState({ modal }));
  }
  componentWillUnmount(): void {
    this.unregister?.();
  }

  private close = (): void => this.setState({ modal: null });
  private run = (btn: ModalButton): void => {
    this.close();
    void btn.onClick?.();
  };

  render(): JSX.Element | null {
    const { modal } = this.state;
    if (!modal) return null;
    return (
      <div className="modal-overlay" onClick={this.close}>
        <div className="modal" role="dialog" aria-modal="true" aria-label={modal.title} onClick={(e): void => e.stopPropagation()}>
          <div className="modal__body">
            {modal.icon && <div className="modal__icon" aria-hidden="true">{modal.icon}</div>}
            <div className="modal__text">
              <h2 className="modal__title">{modal.title}</h2>
              <p className="modal__message">{modal.message}</p>
            </div>
          </div>
          <div className="modal__actions">
            {modal.buttons.map((b, i) => (
              <button
                key={i}
                type="button"
                className={`modal__btn modal__btn--${b.variant ?? "grey"}${b.align === "left" ? " modal__btn--left" : ""}`}
                onClick={(): void => this.run(b)}
              >
                {b.label}
              </button>
            ))}
          </div>
        </div>
      </div>
    );
  }
}
